import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'
import createPlugin from 'logrocket-vuex';
import LogRocket from 'logrocket'
const logrocketPlugin = createPlugin(LogRocket);

import products from './store/products/products'
import testers from './store/testers/testers'
import defects from './store/defects/defects'

import exports from './store/exports/exports'

import users from './store/users/users'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        loading: false,
        oAuthToken: null,
        showMenu:false,
    },
    getters: {
        getLoadingScreen: state => state.loading,
        getShowMenu: state => state.showMenu,
        getToken: state => state.oAuthToken,
        profile: state=>state.users.me
    },
    mutations: {
        setLoading(state, payload) {
            state.loading = payload
        },
        setShowMenu(state, payload) {
            state.showMenu = payload
        },
        setOauthToken(state, payload) {
            state.oAuthToken = payload
        }
    },
  actions: {
      getMyProfile: ({commit}, ApiClient) => {
          return ApiClient.User.getMe().then(res => {
              if (res.status === 200) {
                  var user = checkUserRole(res.data)
                  commit('setMe', user)
              }
              return user
          }).catch((err) => {
              return err
          });
      },
      initApp: ({dispatch}) => {
          Promise.all([  dispatch('products/getAttributesFromApi'), dispatch('products/getProductsFromApi')]).then(function(values) {
              return true
          });




      }
  },
    modules: {
        products,
        testers,
        defects,

        exports,
         users
    },
    plugins: [
        createPersistedState(),
        logrocketPlugin
    ],
})